module.exports = __webpack_public_path__ + "img/4.602653b8.jpg";